<template>
    <v-badge v-if="displayBadge" :content="count" color="error" inline class="reservation-badge ms-2" />
</template>

<script>
export default {
    name: "ReservationBadge",
    props: {
        count: {
            type: Number,
            default: 0,
        },
        show: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        displayBadge() {
            return this.show && this.count != null && this.count > 0;
        },
    },
};
</script>
